<template>
  <main class="container py-4">

    <section class="dashboard-hero mb-4">

      <div>
        <p class="text-uppercase small mb-2">
          Book Store Management
        </p>

        <h1>
          Welcome to your dashboard
        </h1>

        <p class="mb-0">
          Manage your books, wishlist,
          and inventory in one place.
        </p>
      </div>

      <router-link
        to="/books/add"
        class="btn btn-light btn-lg"
      >
        + Add New Book
      </router-link>

    </section>

    <div class="row g-4">

      <div class="col-md-6 col-xl-3">
        <div class="stat-card">
          <div class="stat-icon">📚</div>

          <div>
            <span>Total Books</span>

            <h2>
              {{ booksCount }}
            </h2>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="stat-card">
          <div class="stat-icon">❤️</div>

          <div>
            <span>Wishlist</span>

            <h2>
              {{ wishlistCount }}
            </h2>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="stat-card">
          <div class="stat-icon">🏷️</div>

          <div>
            <span>Categories</span>

            <h2>
              {{ categoriesCount }}
            </h2>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="stat-card">
          <div class="stat-icon">💰</div>

          <div>
            <span>Average Price</span>

            <h2>
              {{ formatPrice(averagePrice) }}
            </h2>
          </div>
        </div>
      </div>

    </div>

    <section class="mt-5">

      <div
        class="d-flex justify-content-between
               align-items-center mb-3"
      >
        <div>
          <h3 class="mb-1">
            Quick Access
          </h3>

          <p class="text-muted mb-0">
            Navigate to the most used sections.
          </p>
        </div>
      </div>

      <div class="row g-4">

        <div class="col-md-4">
          <router-link
            to="/books"
            class="quick-card"
          >
            <span>📖</span>

            <div>
              <h5>Browse Books</h5>

              <p>
                Search, filter and manage books.
              </p>
            </div>
          </router-link>
        </div>

        <div class="col-md-4">
          <router-link
            to="/wishlist"
            class="quick-card"
          >
            <span>❤️</span>

            <div>
              <h5>My Wishlist</h5>

              <p>
                Review your saved books.
              </p>
            </div>
          </router-link>
        </div>

        <div class="col-md-4">
          <router-link
            to="/books/add"
            class="quick-card"
          >
            <span>➕</span>

            <div>
              <h5>Add a Book</h5>

              <p>
                Add a new book to inventory.
              </p>
            </div>
          </router-link>
        </div>

      </div>

    </section>

  </main>
</template>

<script>
export default {
  name: 'Dashboard',

  computed: {
    booksCount() {
      return this.$store.getters.booksCount
    },

    wishlistCount() {
      return this.$store.getters.wishlistCount
    },

    categoriesCount() {
      return this.$store.getters.categoriesCount
    },

    averagePrice() {
      return this.$store.getters.averagePrice
    }
  },

  methods: {
    formatPrice(value) {
      return new Intl.NumberFormat(
        'en-SA',
        {
          style: 'currency',
          currency: 'SAR',
          maximumFractionDigits: 0
        }
      ).format(value)
    }
  }
}
</script>

<style scoped>

.dashboard-hero {
  background:
    linear-gradient(
      135deg,
      #5b2de8,
      #8b5cf6,
      #ec4899
    );

  color:
    #ffffff;

  border-radius:
    22px;

  padding:
    45px;

  box-shadow:
    0 15px 35px
    rgba(
      108,
      59,
      255,
      0.2
    );

  position:
    relative;

  overflow:
    hidden;
}

.dashboard-hero::after {
  content:
    "";

  position:
    absolute;

  width:
    220px;

  height:
    220px;

  right:
    -70px;

  top:
    -100px;

  border-radius:
    50%;

  background:
    rgba(
      255,
      255,
      255,
      0.1
    );
}

.dashboard-hero h1,
.dashboard-hero p {
  color:
    #ffffff;
}

.stat-card {
  background:
    var(--surface);

  border:
    1px solid var(--border);

  border-radius:
    18px;

  padding:
    25px;

  box-shadow:
    0 8px 25px
    rgba(
      108,
      59,
      255,
      0.07
    );

  transition:
    0.25s;
}

.stat-card:hover {
  transform:
    translateY(-5px);

  box-shadow:
    0 14px 30px
    rgba(
      108,
      59,
      255,
      0.13
    );
}

.stat-icon {
  font-size:
    2rem;
}
.dashboard-hero h1 {
  font-weight: 700;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 25px;

  display: flex;
  align-items: center;
  gap: 18px;

  box-shadow: 0 5px 20px
    rgba(0, 0, 0, 0.06);

  transition: 0.25s;
}

.stat-card:hover {
  transform: translateY(-4px);
}

.stat-icon {
  font-size: 2rem;
}

.stat-card span {
  color: #6c757d;
  font-size: 0.9rem;
}

.stat-card h2 {
  margin: 5px 0 0;
  font-weight: 700;
}

.quick-card {
  text-decoration: none;
  color: inherit;
  background: white;

  padding: 24px;
  border-radius: 16px;

  display: flex;
  gap: 15px;
  align-items: center;

  box-shadow: 0 5px 20px
    rgba(0, 0, 0, 0.06);

  transition: 0.25s;
}

.quick-card:hover {
  color: inherit;
  transform: translateY(-4px);
}

.quick-card > span {
  font-size: 2rem;
}

.quick-card p {
  color: #6c757d;
  margin: 0;
}

@media (max-width: 768px) {
  .dashboard-hero {
    flex-direction: column;
    align-items: flex-start;
    padding: 30px;
  }
}
</style>